import React from "react";
import { Col, Row } from "react-bootstrap";
// import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiGit,
  DiSqllite,
} from "react-icons/di";
import { SiFirebase, SiCss3, SiHtml5 } from "react-icons/si";
// import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={2} md={2} className="tech-icons" title="HTML5">
        <SiHtml5 />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="JavaScript">
        <DiJavascript1 />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="CSS3">
        <SiCss3 />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="Node.js">
        <DiNodejs />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="React">
        <DiReact />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="Git">
        <DiGit />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="Firebase">
        <SiFirebase />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="SQLite">
        <DiSqllite />
      </Col>
    </Row>
  );
}

export default Techstack;
